<template>
    <div>
        <div class="title whiteBox">{{ $t('view.个人信息') }}</div>
        <div class="whiteBox">
            <el-form ref="form" :model="form" label-width="120px" style="width: 90%;margin: 20px auto; display: flex;justify-content: space-between; flex-wrap: wrap;" :rules="rules">
                <el-form-item :label="$t('view.姓名')">
                    <el-input size="mini"  style="width: 320px" v-model="form.nickName"></el-input>
                </el-form-item>
                <el-form-item :label="$t('view.登录账号')">
                    <el-input size="mini" disabled style="width: 320px" v-model="form.userName"></el-input>
                </el-form-item>
                <el-form-item :label="$t('view.单位名称')">
                    <el-input size="mini" disabled style="width: 320px" v-model="form.supplierName"></el-input>
                </el-form-item>
                <el-form-item :label="$t('view.联系电话')" prop="phonenumber">
                    <el-input size="mini" disabled style="width: 320px" v-model="form.phonenumber"></el-input>
                </el-form-item>
                <el-form-item :label="$t('view.电子邮箱')" prop="email">
                    <el-input size="mini" style="width: 320px" v-model="form.email"></el-input>
                </el-form-item>
                <el-form-item v-if="form.enterpriseCategory!=1" :label="$t('view.是否法人')" prop="isLegalRepresentative">
                    <el-radio-group disabled v-model="form.isLegalRepresentative" style="width: 320px" >
                        <el-radio  label="Y" style="width: 145px;">{{ $t('view.是') }}</el-radio>
                        <el-radio  label="N" style="width: 145px;">{{ $t('view.否') }}</el-radio>
                    </el-radio-group>                
                </el-form-item>
                <!-- <el-form-item v-if="form.isLegalRepresentative!='Y'" :label="$t('view.投标授权委托书')" prop="authorizationFileList">
                    <div  style="display: flex;">
                        <File v-if="form.authorizationFileList&&form.authorizationFileList[0]" :listName="'authorizationFileList'" :file="form.authorizationFileList[0]"></File>
                    </div>
                </el-form-item>
                <el-form-item v-if="form.isLegalRepresentative!='Y'"  :label="$t('view.委托书有效期 ')" prop="authorizationList">
                    <el-date-picker v-model="form.authorizationStart" disabled style="width: 150px;"  value-format="yyyy-MM-dd" type="date" :placeholder="$t('view.请选择开始时间')"></el-date-picker>
                    <span style="margin: 0 8px">-</span> 
                    <el-date-picker v-model="form.authorizationEnd" disabled style="width: 150px;" value-format="yyyy-MM-dd"  type="date" :placeholder="$t('view.请选择结束时间')"></el-date-picker>
                </el-form-item> -->
            </el-form>
            <div  style="text-align: center;">
                <el-button size="mini" type="primary" @click="profileUpdateInfo">{{ $t('view.保存') }}</el-button>
            </div>
        </div>
    </div>
  </template>
    
<script>
import {profileGetInfo,profileUpdateInfo} from '@/api/login'
import { mobile, email } from '@/utils/regular.js'
import { uploadFileBpm } from '@/utils/request'
import { getToken } from "@/utils/auth";
import File from '@/components/file.vue'
import {authorizationDownLoad,getAuthorization} from '@/api/project'


  export default {
    components:{File},
    data(){
        const validateEmail = (rule, value, callback) => {
            if (!value) {
                callback(new Error(this.$t('view.请输入')))
            } else if (!email.test(value)) {
                callback(new Error(this.$t('view.格式有误')))
            } else {
                callback()
            }
        }
        return{
            headers: {
                Authorization:getToken(),
            },
            uploadFileBpm,
            BpmData:{type:'qyrzlc'},
            locale: localStorage.getItem('locale')||'zh',
            rules:{ 
                email: [{ required: true, trigger: 'blur', validator: validateEmail }],
                phonenumber:[{ required: true, trigger: 'blur',  message: this.$t('view.请输入')}],
                authorizationFileList:[{ required: true, message: this.$t('view.请上传'), trigger: "change" }],
            },
            form:{
                authorizationFileList:[]
            }
        }
    },
    created(){
        this.profileGetInfo()
    },  
    methods:{
        // 删除
        handleRemove(list, file, fileList) {
            this.$set(this.form,list,[])
            fileList.map(item=>{
                this.form[list].push({
                    fileName:item.response.originalFilename,
                    filePath:item.response.fileName,
                    url: item.response.url, 
                })
            })
        },
        // 上传文件
        successList(list,res,file){
            if(!list)
            list=[]
            list.push({
                fileName:file.response.data.newFileName,
                filePath:file.response.data.url,
                url: file.response.data.url, 
                type:file.response.data.newFileName.split(".").pop(),
                fileSize:file.size,
                bpmFileId:file.response.data.bpmFileId

            })
        },
        beforeAvatarUpload(file){
            // image/png zip rar pdf
            if((!file.type.includes('pdf'))&&(!file.type.includes('image'))&&(!file.type.includes('zip'))&&(!file.type.includes('application/x-compressed'))){
                this.$message.error(this.$t('view.格式有误'));
                return false
            }
            return true
        },
        // 修改用户信息
        profileUpdateInfo(){
            this.$refs.form.validate(valid => {
                if (valid) {
                    profileUpdateInfo(this.form).then(res=>{
                        if(res.code==200)
                        this.$message.success(this.$t('view.保存成功'))
                    })
                }
            })
        },  
        downloadTemplate(){
            authorizationDownLoad().then(res=>{
                const blob = new Blob([res]);
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = this.$t('view.投标授权委托书模板.docx');
                link.click();
            })
        },
        // 获取用户信息
        profileGetInfo(){
            profileGetInfo().then(res=>{
                this.form=res.data
                if(this.form.enterpriseCategory==1)
                this.form.isLegalRepresentative='Y'
                getAuthorization().then(res=>{
                    let data=res.data
                    this.form.authorizationFileList=data.authorizationFileList?data.authorizationFileList:[]
                    this.form.isLegalRepresentative= data.isLegalRepresentative
                    this.form.authorizationEnd=data.authorizationEnd
                    this.form.authorizationStart=data.authorizationStart
                })
            }) 
        }
    }
};
</script>
<style lang="scss" scoped>
    .title{
        font-size: 16px;
        font-weight: 600;
        color: #333333;
    }
    ::v-deep.hide .el-upload--picture-card {
        display: none;
    }
    ::v-deep.hide .el-upload--text{
        display: none;
    }
</style>
   